// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Asjh","badges":"styles_badges__2-kmW"};